import Vue from 'vue'
import { Message } from 'element-ui'
import 'element-ui/lib/theme-chalk/base.css'
import 'element-ui/lib/theme-chalk/icon.css'
import 'element-ui/lib/theme-chalk/message.css'
import 'element-ui/lib/theme-chalk/message-box.css'
import '@/styles/app-message-box.css'
import { installAppDialog } from '@/utils/appDialog'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false
Vue.prototype.$message = Message
installAppDialog(Vue)

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
